var map = {
	"./apk.svg": 1522,
	"./aside-icon1.svg": 900,
	"./aside-icon2.svg": 5316,
	"./aside-icon3.svg": 2065,
	"./discord.svg": 6284,
	"./google-play.svg": 9416,
	"./menu.svg": 3881,
	"./store.svg": 8149,
	"./twitter.svg": 4616
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;